import { Component, input } from '@angular/core';
import { MtrFormFieldModule } from '@mortar/angular/components/atomic/form-field';
import { MtrInputModule } from '@mortar/angular/components/atomic/input';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { InputComponent } from 'app/driver-pay/persistence/core/components/inputs/InputComponent';
import { MteStackWrapper } from '@mortar/angular/elements/atomic/stack';

@Component({
  selector: 'number-input',
  standalone: true,
  template: `
    <mte-stack [w]="width()">
      <mtr-form-field>
        <input #inputElement mtr-input id="{{ id() }}" [formControl]="inputFormControl()" type="number" />
      </mtr-form-field>
    </mte-stack>
  `,
  imports: [MtrFormFieldModule, MtrInputModule, FormsModule, ReactiveFormsModule, MteStackWrapper],
})
export class NumberInputComponent implements InputComponent {
  inputFormControl = input.required<FormControl<number> | FormControl<number | null>>();
  id = input.required<string>();
  width = input<string>('80px');
}
